module.exports = __webpack_public_path__ + "img/cadiz-logo-icon.433687d6.png";